<template>
<div>
 <Header @getLanguageMap='getLanguageMap'></Header>
<!-- <div class="crumbs" style="padding-top: 120px;">
  <div class="container">
    <p class="title">{{languageMap['公司地图']}}</p>
    <div class="childs"> <a href="/#/">{{languageMap['主页']}}</a> &gt; <a href="/#/lianxi/">{{languageMap['联系我们']}}</a> &gt; <a href="/#/lianxi/ditu/">{{languageMap['公司地图']}}</a> &gt;  </div>
  </div>
</div> -->
<NavigationBar></NavigationBar>
<div class="main">
  <div class="container">
    <div class="maxTitle"> <span class="title">{{languageMap['公司地图']}}</span>
      <div class="sub"></div>
    </div>
    <div class="head">
     <div id="dituContent" style="width: 697px; height: 550px;  overflow: hidden; position: relative; z-index: 0;">
       <img src="/templets/111/picture/ditu.jpg"/>
     </div>
    </div>
   </div>
</div>
 <Footer></Footer>
</div>
</template>

<style scoped>
html,body{margin:0;padding:0;}
.iw_poi_title {color:#CC5522;font-size:14px;font-weight:bold;overflow:hidden;padding-right:13px;white-space:nowrap}
.iw_poi_content {font:12px arial,sans-serif;overflow:visible;padding-top:4px;white-space:-moz-pre-wrap;word-wrap:break-word}

/* about.css */
.main .head {
	padding:40px 0;
}
.main .head:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .head .left {
	width:590px;
	height:250px;
	float:left;
}
.main .head .left img {
	width:100%;
	height:100%;
	vertical-align:middle;
}
.main .head .right {
	width:500px;
	float:right;
	margin-right:20px;
}
.main .head .right p {
	color:#666;
	font-size:14px;
	line-height:22px;
}
.main .content:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .content .contentTitle {
	position:relative;
	line-height:28px;
}
.main .content .contentTitle span {
	position:relative;
	z-index:1;
	color:#333333;
	font-size:18px;
	background:#fff;
	padding-right:12px;
}
.main .content .contentTitle .sub {
	position:absolute;
	top:14px;
	left:0px;
	height:1px;
	background:#d6d6d6;
	width:100%;
}
.main .content .left {
	width:685px;
	float:left;
}
.main .content .left ul {
	margin:18px 0;
	padding-left:20px;
}
.main .content .left li {
	height:28px;
	line-height:28px;
	color:#666;
	font-size:14px;
	list-style:disc;
}
.main .content .left .info {
	color:#666;
	font-size:14px;
	line-height:22px;
	margin:18px 0;
}
.main .content .right {
	width:445px;
	float:right;
}
.main .content .right .contentTitle {
	padding-bottom:30px;
}
.main .content .right .lineTitle {
	padding-top:14px;
	font-size:14px;
	color:#666;
	line-height:32px;
}
.main .content .right .inputText {
	color:#666;
	width:354px;
	height:36px;
	border:1px solid #b8b8b8;
	background:#fff;
	padding-left:12px;
}
.main .content .right .textArea {
	color:#666;
	width:412px;
	height:143px;
	padding:12px;
	border:1px solid #b8b8b8;
}
.main .content .right .inputSub {
	font-size:14px;
	cursor:pointer;
	width:90px;
	height:34px;
	line-height:34px;
	color:#fff;
	background:#999;
	text-align:center;
	margin-top:14px;
	border:0;
}
.main .content .right .inputSub {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.main .content .right .inputSub:hover {
	background:#717070;
}
.main .customer {
	position:relative;
	border-bottom:1px solid #d6d6d6;
}
.main .customer .title {
	line-height:36px;
	color:#333333;
	font-size:18px;
	padding-bottom:20px;
}
.main .customer .customerContent {
	position:relative;
	width:100%;
	height:290px;
	overflow:hidden;
}
.main .customer .customerContent .contents {
	position:absolute;
	top:0px;
	left:0px;
}
.main .customer .customerContent .child {
	position:absolute;
	top:0;
	left:0px;
	width:566px;
	height:290px;
}
.main .customer .customerContent .child .childContent {
	position:relative;
	width:520px;
	height:127px;
	padding:24px;
	background-color:#f1f1f1;
}
.main .customer .customerContent .child .childContent p {
	color:#777777;
	font-size:14px;
	line-height:24px;
}
.main .customer .customerContent .child .childContent .pointer {
	position:absolute;
	bottom:-11px;
	height:11px;
	left:106px;
}
.main .customer .customerContent .child .childFoot {
	position:relative;
	height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon {
	float:left;
	height:80px;
	line-height:80px;
	text-align:center;
}
.main .customer .customerContent .child .childFoot .childIcon img {
	max-height:80px;
	vertical-align:middle;
}
.main .customer .customerContent .child .childFoot .childInfo {
	float:left;
	padding-left:20px;
}
.main .customer .customerContent .child .childFoot .childInfo .childTitle {
	color:#777777;
	font-size:14px;
	line-height:24px;
	padding-top:15px;
}
.main .customer .customerContent .child .childFoot .childInfo .childEn {
	line-height:22px;
	color:#939393;
	font-size:12px;
	font-family:Arial, Helvetica, sans-serif;
}
.main .customer .customerBtn {
	position:absolute;
	bottom:54px;
	cursor:pointer;
	z-index:1;
}
.main .customer .customerBtn.leftBtn {
	right:50px;
}
.main .customer .customerBtn.rightBtn {
	right:0px;
}
.main .customerLogo {
	position:relative;
	padding-top:34px;
}
.main .customerLogo .title {
	line-height:36px;
	color:#333333;
	font-size:18px;
	padding-bottom:36px;
}
.main .customerLogo .customerLogoContent {
	position:relative;
	height:156px;
	width:100%;
	overflow:hidden;
}
.main .customerLogo .customerLogoContent .contents {
	position:absolute;
	top:0px;
	left:0px;
}
.main .customerLogo .customerLogoContent .child {
	position:absolute;
	top:0px;
	width:222px;
	height:154px;
	line-height:154px;
	text-align:center;
	border:1px solid #e2e2e2;
}
.main .customerLogo .customerLogoContent .child {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.main .customerLogo .customerLogoContent .child:hover {
	-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-o-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
}
.main .customerLogo .customerLogoContent .child img {
	vertical-align:middle;
	max-width:90%;
	max-height:90%;
}
.main .customerLogo .logoBtn {
	position:absolute;
	top:164px;
	cursor:pointer;
}
.main .customerLogo .logoBtn.leftBtn {
	left:-60px;
}
.main .customerLogo .logoBtn.rightBtn {
	right:-60px;
}
@media (max-width: 639px) {
.main .head {
	padding:20px 0;
}
.main .head .left {
	width:100%;
	height:auto;
	float:none;
}
.main .head .left img {
	width:100%;
	height:auto;
}
.main .head .right {
	width:100%;
	float:none;
	margin:10px 0;
}
.main .head .right p {
	font-size:12px;
	line-height:18px;
}
.main .content .contentTitle {
	line-height:20px;
}
.main .content .contentTitle span {
	font-size:14px;
	padding-right:8px;
}
.main .content .contentTitle .sub {
	top:10px;
}
.main .content .left {
	width:100%;
	float:none;
}
.main .content .left ul {
	margin:10px 0;
	padding-left:20px;
}
.main .content .left li {
	height:20px;
	line-height:20px;
	font-size:12px;
}
.main .content .left .info {
	font-size:12px;
	line-height:20px;
	margin:10px 0;
}
.main .content .right {
	width:100%;
	float:none;
}
.main .content .right .contentTitle {
	padding-bottom:0px;
}
.main .content .right .lineTitle {
	padding-top:10px;
	font-size:12px;
	line-height:26px;
}
.main .content .right .inputText {
	width:280px;
	height:30px;
	padding-left:6px;
}
.main .content .right .textArea {
	width:274px;
	height:143px;
	padding:6px;
}
.main .content .right .inputSub {
	font-size:12px;
	width:90px;
	height:34px;
	line-height:34px;
	margin-top:14px;
}
.main .customer {
	padding-top:20px;
}
.main .customer .title {
	line-height:24px;
	font-size:14px;
	padding-bottom:10px;
}
.main .customer .customerContent {
	width:100%;
	height:290px;
}
.main .customer .customerContent .contents {
	width:100%;
}
.main .customer .customerContent .child {
	width:100%;
	height:290px;
}
.main .customer .customerContent .child .childContent {
	width:auto;
	height:160px;
	padding:12px;
}
.main .customer .customerContent .child .childContent p {
	font-size:12px;
	line-height:20px;
}
.main .customer .customerContent .child .childContent .pointer {
	bottom:-11px;
	height:11px;
	left:106px;
}
.main .customer .customerContent .child .childFoot {
	height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon {
	height:80px;
	line-height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon img {
	max-height:80px;
}
.main .customer .customerContent .child .childFoot .childInfo {
	padding-left:20px;
}
.main .customer .customerContent .child .childFoot .childInfo .childTitle {
	font-size:14px;
	line-height:24px;
	padding-top:15px;
}
.main .customer .customerContent .child .childFoot .childInfo .childEn {
	line-height:22px;
	font-size:12px;
}
.main .customer .customerBtn {
	bottom:54px;
}
.main .customer .customerBtn.leftBtn {
	right:50px;
}
.main .customer .customerBtn.rightBtn {
	right:0px;
}
.main .customerLogo {
	padding-top:34px;
}
.main .customerLogo .title {
	line-height:36px;
	font-size:18px;
	padding-bottom:36px;
}
.main .customerLogo .customerLogoContent {
	height:77px;
}
.main .customerLogo .customerLogoContent .child {
	width:90px;
	height:75px;
	line-height:75px;
}
.main .customerLogo .logoBtn {
	top:122px;
}
.main .customerLogo .logoBtn.leftBtn {
	left:0px;
}
.main .customerLogo .logoBtn.rightBtn {
	right:0px;
}
}
@media (min-width: 640px) and (max-width:1023px ) {
.main .head {
	padding:40px 0;
}
.main .head .left {
	width:100%;
	height:auto;
	float:none;
}
.main .head .left img {
	width:100%;
	height:auto;
}
.main .head .right {
	width:100%;
	float:none;
	margin:10px 0;
}
.main .head .right p {
	font-size:14px;
	line-height:22px;
}
.main .content .contentTitle {
	line-height:28px;
}
.main .content .contentTitle span {
	font-size:18px;
	padding-right:12px;
}
.main .content .contentTitle .sub {
	top:14px;
}
.main .content .left {
	width:100%;
	float:none;
}
.main .content .left ul {
	margin:18px 0;
	padding-left:20px;
}
.main .content .left li {
	height:28px;
	line-height:28px;
	font-size:14px;
}
.main .content .left .info {
	font-size:14px;
	line-height:22px;
	margin:18px 0;
}
.main .content .right {
	width:100%;
	float:none;
}
.main .content .right .contentTitle {
	padding-bottom:0px;
}
.main .content .right .lineTitle {
	padding-top:14px;
	font-size:14px;
	line-height:32px;
}
.main .content .right .inputText {
	width:90%;
	height:36px;
	padding-left:12px;
}
.main .content .right .textArea {
	width:90%;
	height:143px;
	padding:12px;
}
.main .content .right .inputSub {
	font-size:14px;
	width:90px;
	height:34px;
	line-height:34px;
	margin-top:14px;
}
.main .customer {
	padding-top:20px;
}
.main .customer .title {
	line-height:36px;
	font-size:18px;
	padding-bottom:20px;
}
.main .customer .customerContent {
	width:100%;
	height:290px;
}
.main .customer .customerContent .child {
	width:600px;
	height:290px;
}
.main .customer .customerContent .child .childContent {
	width:552px;
	height:127px;
	padding:24px;
}
.main .customer .customerContent .child .childContent p {
	font-size:14px;
	line-height:24px;
}
.main .customer .customerContent .child .childContent .pointer {
	bottom:-11px;
	height:11px;
	left:106px;
}
.main .customer .customerContent .child .childFoot {
	height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon {
	height:80px;
	line-height:80px;
}
.main .customer .customerContent .child .childFoot .childIcon img {
	max-height:80px;
}
.main .customer .customerContent .child .childFoot .childInfo {
	padding-left:20px;
}
.main .customer .customerContent .child .childFoot .childInfo .childTitle {
	font-size:14px;
	line-height:24px;
	padding-top:15px;
}
.main .customer .customerContent .child .childFoot .childInfo .childEn {
	line-height:22px;
	font-size:12px;
}
.main .customer .customerBtn {
	bottom:54px;
}
.main .customer .customerBtn.leftBtn {
	right:50px;
}
.main .customer .customerBtn.rightBtn {
	right:0px;
}
.main .customerLogo {
	padding-top:34px;
}
.main .customerLogo .title {
	line-height:36px;
	font-size:18px;
	padding-bottom:36px;
}
.main .customerLogo .customerLogoContent {
	height:156px;
}
.main .customerLogo .customerLogoContent .child {
	width:180px;
	height:130px;
	line-height:130px;
}
.main .customerLogo .logoBtn {
	top:154px;
}
.main .customerLogo .logoBtn.leftBtn {
	left:0px;
}
.main .customerLogo .logoBtn.rightBtn {
	right:0px;
}
}
@media (min-width: 1024px) and (max-width:1199px ) {
.main .head {
	padding:40px 0;
}
.main .head .left {
	width:480px;
	height:204px;
}
.main .head .right {
	width:408px;
	margin-right:20px;
}
.main .content .left {
	width:560px;
}
.main .content .right {
	width:362px;
}
.main .content .right .textArea {
	width:340px;
}
.main .customer .title {
	line-height:36px;
	font-size:18px;
	padding-bottom:20px;
}
.main .customer .customerContent {
	height:290px;
}
.main .customer .customerContent .child {
	width:462px;
	height:236px;
}
.main .customer .customerContent .child .childContent {
	width:424px;
	height:103px;
	padding:8px 12px;
}
.main .customer .customerContent .child .childContent p {
	font-size:12px;
	line-height:18px;
}
.main .customer .customerBtn {
	bottom:54px;
}
.main .customer .customerBtn.leftBtn {
	right:50px;
}
.main .customer .customerBtn.rightBtn {
	right:0px;
}
.main .customerLogo {
	padding-top:34px;
}
.main .customerLogo .customerLogoContent {
	height:156px;
}
.main .customerLogo .customerLogoContent .child {
	width:181px;
	height:125px;
	line-height:125px;
}
.main .customerLogo .logoBtn {
	top:150px;
}
.main .customerLogo .logoBtn.leftBtn {
	left:0px;
}
.main .customerLogo .logoBtn.rightBtn {
	right:0px;
}
}
@media (min-width: 1200px) and (max-width:1439px ) {
}
@media (min-width: 1440px) and (max-width:1920px ) {
}


</style>

<script>
import store from "@/store";
import config from "@/config";
import Header from "@/components/front/Header.vue";
import Footer from "@/components/front/Footer.vue";
import NavigationBar from "@/components/front/NavigationBar.vue";
export default {
  data() {
    return {
		languageMap:{}
    };
  },
  mounted() {

      
  },
  beforeDestroy(){

  },
  methods: {
    init(){

    //this.languageMap['this.languageMap['创建和初始化地图']函数']：
    function initMap(){
        createMap();//this.languageMap['创建地图']
        setMapEvent();//this.languageMap['设置地图事件']
        addMapControl();//this.languageMap['向地图添加控件']
        addMarker();//this.languageMap['向地图中添加marker']
    }
    
    //this.languageMap['创建地图']函数：
    function createMap(){
        var map = new BMap.Map("dituContent");//this.languageMap['在百度地图容器中创建一个地图']
        var point = new BMap.Point(116.663289,39.89644);//this.languageMap['定义一个中心点坐标']
        map.centerAndZoom(point,17);//this.languageMap['设定地图的中心点和坐标并将地图显示在地图容器中']
        window.map = map;//this.languageMap['将map变量存储在全局']
    }
    
    //this.languageMap['地图事件设置函数']：
    function setMapEvent(){
        map.enableDragging();//this.languageMap['启用地图拖拽事件，默认启用'](this.languageMap['this.languageMap['可不写']'])
        map.enableScrollWheelZoom();//this.languageMap['启用地图滚轮放大缩小']
        map.enableDoubleClickZoom();//this.languageMap['启用鼠标双击放大，默认启用'](this.languageMap['this.languageMap['可不写']'])
        map.enableKeyboard();//this.languageMap['启用键盘上下左右键移动地图']
    }
    
    //this.languageMap['地图控件添加函数']：
    function addMapControl(){
        //this.languageMap['向地图中添加缩放控件']
	var ctrl_nav = new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_LEFT,type:BMAP_NAVIGATION_CONTROL_LARGE});
	map.addControl(ctrl_nav);
        //this.languageMap['向地图中添加缩略图控件']
	var ctrl_ove = new BMap.OverviewMapControl({anchor:BMAP_ANCHOR_BOTTOM_RIGHT,isOpen:1});
	map.addControl(ctrl_ove);
        //this.languageMap['向地图中添加比例尺控件']
	var ctrl_sca = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
	map.addControl(ctrl_sca);
    }
    
	//this.languageMap['标注点数组']
	let title= this.languageMap["北京明瑞之光科技有限公司"];
	let content=this.languageMap["电话：010-80816559<br/>传真：010-80816559-810"];
	console.log(title+'==='+content)
    var markerArr = [{title:title, content:content, point:"116.662741|39.895803",isOpen:0,icon:{w:21,h:21,l:0,t:0,x:6,lb:5}}
		 ];
    //this.languageMap['创建marker']
    function addMarker(){
        for(var i=0;i<markerArr.length;i++){
            var json = markerArr[i];
            var p0 = json.point.split("|")[0];
            var p1 = json.point.split("|")[1];
            var point = new BMap.Point(p0,p1);
			var iconImg = createIcon(json.icon);
            var marker = new BMap.Marker(point,{icon:iconImg});
			var iw = createInfoWindow(i);
			var label = new BMap.Label(json.title,{"offset":new BMap.Size(json.icon.lb-json.icon.x+10,-20)});
			marker.setLabel(label);
            map.addOverlay(marker);
            label.setStyle({
                        borderColor:"#808080",
                        color:"#333",
                        cursor:"pointer"
            });
			
			(function(){
				var index = i;
				var _iw = createInfoWindow(i);
				var _marker = marker;
				_marker.addEventListener("click",function(){
				    this.openInfoWindow(_iw);
			    });
			    _iw.addEventListener("open",function(){
				    _marker.getLabel().hide();
			    })
			    _iw.addEventListener("close",function(){
				    _marker.getLabel().show();
			    })
				label.addEventListener("click",function(){
				    _marker.openInfoWindow(_iw);
			    })
				if(!!json.isOpen){
					label.hide();
					_marker.openInfoWindow(_iw);
				}
			})()
        }
    }
    //this.languageMap['创建InfoWindow']
    function createInfoWindow(i){
        var json = markerArr[i];
        var iw = new BMap.InfoWindow("<b class='iw_poi_title' title='" + json.title + "'>" + json.title + "</b><div class='iw_poi_content'>"+json.content+"</div>");
        return iw;
    }
    //this.languageMap['创建一个Icon']
    function createIcon(json){
        var icon = new BMap.Icon("https://api.map.baidu.com/lbsapi/creatmap/images/us_mk_icon.png", new BMap.Size(json.w,json.h),{imageOffset: new BMap.Size(-json.l,-json.t),infoWindowOffset:new BMap.Size(json.lb+5,1),offset:new BMap.Size(json.x,json.h)})
        return icon;
    }
    
    // initMap();//this.languageMap['创建和初始化地图']

	},
getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    getLanguageMap(e){
	  this.languageMap=e;
	  // this.init();
      this.$emit('getLanguageMap',e)
    }
  },
  components: {
    Header,
    Footer,
    NavigationBar
  }
};
</script>
